import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import './styles.scss';

interface Props {
  name?: string;
}

const CreateCampaignConfirmation: React.FC<Props> = ({ name }) => (
  <div className="create-campaign-confirmation">
    <div className="success-icon">
      <FontAwesomeIcon icon={faCheck} />
    </div>
    <div className="name">{name ? name : 'New campaign'}</div>
    <div className="message">has been created</div>
  </div>
);

export default CreateCampaignConfirmation;
